import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { Button } from '../ui/button';

export const FoodCard = ({ item, onAddToCart, onOpenCustomization }) => {
  const isBundle = (item.item_type || 'standard') === 'bundle';
  const feedsLabel = item.bundle_config?.feeds_label;
  const handleAddClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isBundle = (item.item_type || 'standard') === 'bundle';
    if (isBundle || (item.customization_options && item.customization_options.length > 0)) {
      onOpenCustomization(item);
    } else {
      onAddToCart(item);
    }
  };

  return (
    <motion.div
      data-testid="food-card"
      className="food-card group"
      whileHover={{ y: -4 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <div className="bg-white rounded-2xl overflow-hidden shadow-[0_2px_8px_rgba(0,0,0,0.08)] hover:shadow-[0_8px_24px_rgba(0,0,0,0.12)] transition-shadow duration-300 p-6">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1 flex-wrap">
              <h3 className="text-lg font-bold text-foreground">
                {item.name}
              </h3>
              {isBundle && (
                <span
                  className="text-[10px] uppercase tracking-wide bg-primary/10 text-primary font-semibold px-2 py-0.5 rounded-full"
                  data-testid="bundle-badge"
                >
                  Meal Deal
                </span>
              )}
            </div>
            {isBundle && feedsLabel && (
              <p className="text-xs font-medium text-primary/80 mb-1">{feedsLabel}</p>
            )}
            <p className="text-sm text-muted-foreground leading-relaxed">
              {item.description}
            </p>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-2xl font-bold text-primary">
            {isBundle ? `From £${item.price.toFixed(2)}` : `£${item.price.toFixed(2)}`}
          </span>
          <Button
            data-testid={isBundle ? 'build-bundle-button' : 'add-to-cart-button'}
            aria-label={isBundle ? `Build ${item.name} meal deal` : `Add ${item.name} to basket`}
            title={isBundle ? `Build ${item.name}` : `Add ${item.name} to basket`}
            size={isBundle ? 'default' : 'icon'}
            className={`rounded-full bg-primary text-white hover:bg-primary/90 shadow-md ${isBundle ? 'px-4 h-10 text-sm font-semibold' : 'h-10 w-10'}`}
            onClick={handleAddClick}
            type="button"
          >
            {isBundle ? 'Build Meal' : <Plus className="h-5 w-5" />}
          </Button>
        </div>
      </div>
    </motion.div>
  );
};
